import { BUTTON_ACTION_HEIGHT, DEFAULT_FONT_FAMILY } from 'common/constants';
import { BUTTON_PRIMARY } from 'components/TCButton/styles';
import { SIZE } from 'common/sizes';
import { ButtonWrapper } from 'common/baseComponents'
import styled from 'styled-components';

export const MainContainer = styled.div`
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    flex: 1;
    width: 100%;
    padding: 0px 0px;
    margin: 0px 0px;
`
export const AlertContainer = styled.div`
    display: flex;
    padding: 0px 80px;
`;

export const TabBody = styled.div`
    display:flex;
    padding: 0 0px 0px 0px;
`

export const TitleContainer = styled.div`
    display: flex;
    position:relative;
    height: ${SIZE.SIX}px;
    justify-content: flex-start;
    padding-left: 0px;
    flex:  0 0 auto;    
`


export const Title = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: normal;    
    color: #000;    
    padding-left:0px;
    padding-right:0px;
    
`

export const HalfSection = styled.div`
    display:flex;
    flex-flow:column;
    width: calc(50% - 160px);
`

export const ConfigurationSection = styled.section`
    display:flex;
    padding-top: 47px;
    flex-flow: column;
`

export const SeparatorW = styled.div`
    display:flex;
    width: 100%;
    height: 1px;
    
    background: #707070;
    opacity: 0.4;
    position: absolute;
    bottom: 10px;
    left: ${SIZE.TWO + SIZE.ONE}px;
    width: calc(100% - ${SIZE.FOUR}px) ;
`

export const Close = styled.div`
    position: absolute;
    right: ${SIZE.HALF}px;
    top: ${SIZE.HALF}px;
    &:hover {
        cursor: pointer;
    };
`

export const AlertButtonContainer = styled(ButtonWrapper)`
    margin-left: auto; 
    margin-right: ${SIZE.TWO}px;
    margin-top: auto;
    margin-bottom: auto;

    ${BUTTON_PRIMARY}{
        font-family: Rubik;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        width: ${SIZE.TWENTYFOUR}px;
    }
`

export const AlertBox = styled.div`
    display:flex;
    flex-direction: row;
    margin-bottom: ${SIZE.FOUR}px;
    padding: ${SIZE.TWO}px;
    border: solid 1px #a5a5a5;
    width: calc(100%);
    position: relative;
    align-items:center;
    margin-top: 37px;
`

export const AlertMessage = styled.div`
    margin-left: ${SIZE.TWO}px;
    max-width: calc(100% - ${SIZE.THIRTY_THREE}px);
    font-family: Rubik;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fd7219;
    display:flex;
    align-items:center;
`

export const SeparatorW2 = styled.div`
    display:flex:
    width: 100%;
    height: 1px;
    background:#bdbdbd;  
`

export const SeparatorBoxes = styled.div`
    display: flex;
    width: 80px;
`

export const SeparatorH = styled.div`
    display:flex;
    width: 1px;
    height: calc(100% - 85px);   
    background:#bdbdbd;
`

export const VSeparatorContainer = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    height: 100%;   
    display: flex;
    align-items: end;
    width: 1px;
`

export const ToolTipContainer = styled.div`
    position: absolute;    
    z-index: 100;
    display: none;
    margin: 30px 0px 0px 60px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;

export const ToolTipLabel = styled.div`
  font-family: Rubik;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`;

export const Info = styled.div`
  cursor: pointer;
  position: relative;
  margin:auto;
  padding-left: ${SIZE.ONE}px;
  &:hover + ${ToolTipContainer} {
    display: flex;
  }
  `;